import tw from 'tailwind.macro';

export const AboutContainer = tw.div`px-5 lg:py-24 py-6 mx-auto bg-white flex flex-col text-center w-full mb-12`;

export const AboutTitle = tw.h1`sm:text-3xl text-2xl font-medium mb-4 text-gray-900`;

export const AboutInfo = tw.p`lg:w-2/3 mx-auto leading-relaxed text-base`;
